import { getRoutePathWithId } from '@/utils/router-utils';

export class activationRoutePaths {
  static ROOT = '';
  static ACTIVATION = 'activation';
  static NEW = 'new';
  static INDEX = '';
  static ID = ':id';
  static CONFIGURE = ':id/:section';
  static DASHBOARD = ':id/dashboard';
  static EXHIBITORS = ':id/exhibitors';
  static LISTINGS = ':id/listings';
  static PROFILE = ':id/profile';
  static INFO = ':id/info';
  static COLLECTORS = ':id/collectors';
  static TRANSACTIONS = ':id/transactions';
  static STYLE = ':id/style';
  static LEGAL = ':id/legal';
  static CONTENT = ':id/content';
  static SETTINGS = ':id/settings';
  static AUDIENCE = ':id/audience';
  static VIEWING_ROOMS = ':id/viewing-rooms';
  static CREATE_VIEWING_ROOMS = ':id/viewing-rooms/new';
}

export const getActivationRoute = (path: string, id?: string): string => {
  const fullpath = `${activationRoutePaths.ROOT}/${activationRoutePaths.ACTIVATION}/${path}`;
  if (id) {
    return getRoutePathWithId(fullpath, id);
  }
  return `${activationRoutePaths.ROOT}/${activationRoutePaths.ACTIVATION}/${path}`;
};
